import * as React from "react";
import { IconProps } from "./IconProps";

export const IconRotateClockwise = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9717 5C8.10569 5 4.97168 8.13401 4.97168 12C4.97168 15.866 8.10569 19 11.9717 19C15.018 19 17.6122 17.0536 18.5736 14.3334C18.7577 13.8127 19.329 13.5398 19.8497 13.7238C20.3704 13.9079 20.6434 14.4792 20.4593 14.9999C19.2243 18.4941 15.8919 21 11.9717 21C7.00112 21 2.97168 16.9706 2.97168 12C2.97168 7.02944 7.00112 3 11.9717 3C13.6978 3 15.137 3.42278 16.4199 4.21024C16.9804 4.55425 17.5025 4.96268 18 5.42327V4C18 3.44772 18.4477 3 19 3C19.5523 3 20 3.44772 20 4V8C20 8.55228 19.5523 9 19 9H15C14.4477 9 14 8.55228 14 8C14 7.44772 14.4477 7 15 7H16.7574C16.3034 6.56697 15.8479 6.20581 15.3737 5.91476C14.4165 5.32722 13.3415 5 11.9717 5Z"
          fill={color}
        />
      </svg>
    );
  },
);
